module.exports = __webpack_public_path__ + "585834807536af77d01bb714e142528a.svg";